const PREFETCH_MARGIN = 2;
const DEBOUNCE_MS = 500;

function latLngToTileXY(lat, lng, zoom) {
  const n = Math.pow(2, zoom);
  const x = Math.floor((lng + 180) / 360 * n);
  const rad = lat * Math.PI / 180;
  const y = Math.floor((1 - Math.log(Math.tan(rad) + 1 / Math.cos(rad)) / Math.PI) / 2 * n);
  return { x, y };
}

function buildTileUrl(template, z, x, y) {
  return template.replace("{z}", z).replace("{x}", x).replace("{y}", y);
}

export function initTilePrefetch(map, layerService) {
  let timer = null;

  function prefetch() {
    const layers = layerService.listLayers().filter(
      (l) => l.visible && l.type === "xyz" && l.meta?.sourceType === "raster-tiles" && l.url
    );
    if (!layers.length) return;

    const zoom = Math.floor(map.getZoom());
    const max = Math.pow(2, zoom) - 1;
    const bounds = map.getBounds();

    const sw = latLngToTileXY(bounds.getSouth(), bounds.getWest(), zoom);
    const ne = latLngToTileXY(bounds.getNorth(), bounds.getEast(), zoom);

    // visible range (minY is north because tile Y increases southward)
    const visMinX = Math.min(sw.x, ne.x);
    const visMaxX = Math.max(sw.x, ne.x);
    const visMinY = Math.min(sw.y, ne.y);
    const visMaxY = Math.max(sw.y, ne.y);

    const prefMinX = Math.max(0, visMinX - PREFETCH_MARGIN);
    const prefMaxX = Math.min(max, visMaxX + PREFETCH_MARGIN);
    const prefMinY = Math.max(0, visMinY - PREFETCH_MARGIN);
    const prefMaxY = Math.min(max, visMaxY + PREFETCH_MARGIN);

    for (let x = prefMinX; x <= prefMaxX; x++) {
      for (let y = prefMinY; y <= prefMaxY; y++) {
        if (x >= visMinX && x <= visMaxX && y >= visMinY && y <= visMaxY) continue;
        for (const layer of layers) {
          fetch(buildTileUrl(layer.url, zoom, x, y), { priority: "low" }).catch(() => {});
        }
      }
    }
  }

  function onMapSettle() {
    clearTimeout(timer);
    timer = setTimeout(prefetch, DEBOUNCE_MS);
  }

  map.on("moveend", onMapSettle);
  map.on("zoomend", onMapSettle);
}
